export default __webpack_public_path__ + "static/media/humanoid@2x.7ab574cc.png";